import React, { useState, useEffect } from "react";
import { useInput } from "../../../../common/hooks";
import { Grid, Input, Button } from "semantic-ui-react";
import "./style.less";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { geofenceCategoryValueToTextMap } from "../utils";
import {
  viewAssignedWarehouses,
  setWarehouseSearchQueryFilter,
  setErrorToastMessage,
  assignWarehousesToBuddyblock,
  assignWarehousesToWarehouseFence
} from "../../../../redux/geofence/actions";

function AssignWarehouses({ viewAssignedWarehousesOf }) {
  const selectedPolygon = useSelector(({ geofence }) =>
    geofence.visibleGeofences.find(e => e._id === viewAssignedWarehousesOf)
  );

  const dispatch = useDispatch();

  const visibleWarehouseList = useSelector(
    ({ geofence }) => geofence.visibleWarehouseList,
    shallowEqual
  );
  const warehouseList = useSelector(
    ({ geofence }) => geofence.warehouseList,
    shallowEqual
  );
  const assignedWarehouses =
    selectedPolygon && warehouseList && selectedPolygon.properties.warehouseIds
      ? warehouseList.filter(
          e => selectedPolygon.properties.warehouseIds.indexOf(e.id) !== -1
        )
      : null;
  const [selectedWarehouses, setSelectedWarehouses] = useState(
    assignedWarehouses
  );
  const [searchInputVal, setSearchInputVal] = useInput("");
  useEffect(() => {
    dispatch(setWarehouseSearchQueryFilter(searchInputVal));
  }, [dispatch, searchInputVal]);

  const nonAssignedWarehouses = visibleWarehouseList
    ? visibleWarehouseList.filter(e =>
        selectedWarehouses
          ? selectedWarehouses.find(s => e.id === s.id) === undefined
          : true
      )
    : null;

  useEffect(() => {
    if (assignedWarehouses && !selectedWarehouses) {
      setSelectedWarehouses(assignedWarehouses);
    }
  }, [selectedWarehouses, assignedWarehouses, setSelectedWarehouses]);

  const assignWarehouses = () => {
    if (!selectedWarehouses && !assignedWarehouses) {
      dispatch(viewAssignedWarehouses(null));
      return;
    }
    if (selectedWarehouses.length === assignedWarehouses.length) {
      let same = true;
      for (let i = 0; i < selectedWarehouses.length; i++) {
        let s = selectedWarehouses[i];
        if (assignedWarehouses.find(e => e.id === s.id) === undefined) {
          same = false;
          break;
        }
      }
      if (same) {
        dispatch(viewAssignedWarehouses(null));
        return;
      }
    }

    if (selectedPolygon.properties.fenceCategory === "BUDDY_BLOCK") {
      dispatch(
        assignWarehousesToBuddyblock({
          ...selectedPolygon,
          properties: {
            ...selectedPolygon.properties,
            warehouseIds: selectedWarehouses.map(e => e.id)
          }
        })
      );
    } else {
      dispatch(
        assignWarehousesToWarehouseFence({
          ...selectedPolygon,
          properties: {
            ...selectedPolygon.properties,
            warehouseIds: selectedWarehouses.map(e => e.id)
          }
        })
      );
    }

    dispatch(setWarehouseSearchQueryFilter(""));
    dispatch(viewAssignedWarehouses(null));
  };
  return selectedWarehouses && selectedPolygon && viewAssignedWarehousesOf ? (
    <div className="AssignWarehouses-main">
      <Grid>
        <Grid.Column className="AssignWarehouses-leftBlock" width={7}>
          <h4>{selectedPolygon.properties.name}</h4>
          <h5>
            {Math.round(selectedPolygon.properties.area / 1000000) === 0
              ? Math.round(selectedPolygon.properties.area) + " sq. m"
              : Math.round(selectedPolygon.properties.area / 1000000) +
                " sq. Km"}
          </h5>
          <p className={selectedPolygon.properties.fenceCategory}>
            {
              geofenceCategoryValueToTextMap[
                selectedPolygon.properties.fenceCategory
              ]
            }
          </p>
        </Grid.Column>
        <Grid.Column className="AssignWarehouses-rightBlock" width={9}>
          <Input
            value={searchInputVal}
            onChange={setSearchInputVal}
            className="AssignWarehouses-textBox"
            placeholder="Search by name or number"
            icon="search"
          />
          <div className="AssignWarehouses-assigned">
            <h4>Warehouses Assigned</h4>
            {selectedWarehouses &&
              selectedWarehouses.map(e => (
                <div
                  onClick={() =>
                    setSelectedWarehouses(
                      selectedWarehouses.filter(w => e.id !== w.id)
                    )
                  }
                  key={e.id}
                  className="ui checkbox"
                >
                  <input type="checkbox" checked className="hidden" />
                  <label>
                    <p className="AssignWarehouses-checkboxName">{e.name}</p>
                    <p className="AssignWarehouses-checkboxNumber">
                      {`${e.goodsTypes.join()}, ${e.city}`}
                    </p>
                  </label>
                </div>
              ))}
          </div>
          <br />
          <br />
          <div className="AssignWarehouses-other">
            <h4>All Warehouses</h4>
            <div className="AssignWarehouses-scroll">
              {nonAssignedWarehouses &&
                nonAssignedWarehouses.map(e => (
                  <div
                    onClick={() => {
                      let add = true;
                      if (
                        selectedWarehouses &&
                        selectedPolygon.properties.fenceCategory ===
                          "BUDDY_BLOCK"
                      ) {
                        for (let i = 0; i < selectedWarehouses.length; i++) {
                          let s = selectedWarehouses[i];
                          for (let j = 0; j < e.goodsTypes.length; j++) {
                            if (s.goodsTypes.indexOf(e.goodsTypes[j]) !== -1) {
                              add = false;
                              break;
                            }
                          }
                          if (!add) {
                            break;
                          }
                        }
                      }
                      if (add) {
                        setSelectedWarehouses([e, ...selectedWarehouses]);
                      } else {
                        dispatch(
                          setErrorToastMessage(
                            "Warehouse with same goods type already assigned to Buddy Block !"
                          )
                        );
                      }
                    }}
                    key={e.id}
                    className="ui checkbox"
                  >
                    <input type="checkbox" className="hidden" />
                    <label>
                      <p className="AssignWarehouses-checkboxName">{e.name}</p>
                      <p className="AssignWarehouses-checkboxNumber">
                        {`${e.goodsTypes.join()}, ${e.city}`}
                      </p>
                    </label>
                  </div>
                ))}
            </div>
            <Button onClick={assignWarehouses} primary>
              Done
            </Button>
          </div>
        </Grid.Column>
      </Grid>
    </div>
  ) : null;
}

AssignWarehouses.defaultProps = {};

AssignWarehouses.propTypes = {};

export default AssignWarehouses;
